<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">订单号：</div>
        <el-input v-model="filters.orderid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.suid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">手机号码：</div>
        <el-input v-model="filters.phone" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">时间：</div>
        <el-date-picker v-model="filters.dateTime" type="datetimerange" placeholder="选择时间范围" align="right" size="mini" class="date">
        </el-date-picker>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <div class="flex jce mt-20">
      <button class="ml-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in statusList" :key="index" @click="changeStatus(index)">{{item.name}}</button>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600">
      <el-table-column prop="soid" label="订单ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="suid" label="用户ID" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('suid', scope.row.suid)">{{scope.row.nickname}}({{scope.row.suid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderid" label="订单号" width="" align="center">
      </el-table-column>
      <el-table-column prop="number" label="商品数量" width="" align="center">
      </el-table-column>
      <el-table-column prop="amount" label="金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="total_post" label="运费" width="" align="center">
      </el-table-column>
      <el-table-column prop="phone" label="电话号码" width="" align="center">
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="" align="center">
      </el-table-column>
      <el-table-column prop="address" label="地址" width="" align="center">
      </el-table-column>
      <el-table-column prop="end_pay_time" label="最后付款时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.end_pay_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" fixed="right" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">待付款</div>
          <div v-if="scope.row.status == 1">待发货</div>
          <div v-if="scope.row.status == 2">待收货</div>
          <div v-if="scope.row.status == 3">完成</div>
          <div v-if="scope.row.status == 4">取消</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex">
            <router-link :to="{path: '/shopOrderDetail', query: {suid: scope.row.suid}}" class="blue-small-btn">订单详情</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {shopOrderLists, shopOrderEdit} from '../../../api/api'
export default {
  name: 'shopOrderList',
  mixins: [mixinList],
  data () {
    return {
      filters: {
        p: 1,
        l: 20,
        total: 0,
        sgid: '',
        soid: '',
        suid: '',
        phone: '',
        orderid: '',
        soids: '',
        dateTime: '',
        start_time: '',
        end_time: '',
        status: -1
      },
      statusList: [
        {
          name: '所有',
          value: -1,
          status: 1
        },
        {
          name: '待付款',
          value: 0,
          status: 0
        },
        {
          name: '待发货',
          value: 1,
          status: 0
        },
        {
          name: '待收货',
          value: 2,
          status: 0
        },
        {
          name: '完成',
          value: 3,
          status: 0
        },
        {
          name: '取消',
          value: 4,
          status: 0
        }
      ],
      lists: [],
      listLoading: false,
      dialog: false
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
      this.getList()
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value
      this.filters.p = 1
      this.getList()
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.orderid !== '') {
        params.orderid = filters.orderid
      }
      if (filters.suid !== '') {
        params.suid = filters.suid
      }
      if (filters.phone !== '') {
        params.phone = filters.phone
      }
      if (filters.status !== -1) {
        params.status = filters.status
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      this.listLoading = true
      shopOrderLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    changeOrderinfo (index, oper) {
      let status = this.lists[index].status
      let suid = this.lists[index].suid

      if (oper === 2) {
        status = this.lists[index].status === 1 ? 0 : 1
      }

      let params = {
        status: status,
        suid: suid
      }
      shopOrderEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    dateTimeChange () {
      if (this.filters.dateTime) {
        this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
        this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
      } else {
        this.filters.start_time = ''
        this.filters.end_time = ''
      }
    }
  },
  mounted () {
    this.getList()
  },
  watch: {
    'filters.suid': 'getList',
    'filters.phone': 'getList',
    'filters.orderid': 'getList',
    'filters.dateTime': 'dateTimeChange',
    'filters.start_time': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopOrderList.vue